import Header from "../../components/Header/Header-main";
import Input from "../../components/Input/Input-main";
import Searchbar from "../../components/Searchbar/Searchbar-main";
import PopularLocation from "../../components/PopularLocation/PopularLocation-main";

import Hosting from "../../components/Hosting/Hosting-main";
import TopBg from "../../components/TopBg/TopBg-main";
import Login_Signup from "../login-signup/login-signup";
import { useEffect, useState } from "react";
import HeaderRes from "../../components/Header-3/Header";
import SubHeader from "../../components/Subheader/subheader";

const Home = () => {
  const [show, setShow] = useState(-1);

  const handleShow = () => {
    setShow(0);
  };
  const handleCloseShow = () => {
    if (show !== -1) {
      setShow(-1);
    }
  };
  return (
    <>
      <Login_Signup trigger={show} handleCloseShow={handleCloseShow} />
      <div className=" justify-center">
        {/* <HeaderRes/> */}
        <Header handleShow={handleShow} />
        <div className="invisible md:visible relative top-[35px] w-[88.5vw] flex flex-col mx-auto justify-center">
          <Searchbar />
        </div>
        <TopBg />

        <Input />

        <PopularLocation />
        <Hosting />

      </div>
    </>
  );
};

export default Home;
